import ConvertUkTimeZone from "../convert-time-zone";
import days from "./Days";

function CheckDay(today: any) {
  const date: any = ConvertUkTimeZone();
  return today
    ? days[new Date(date).getDay()]
    : days[new Date(date).getDay() - 1 < 0 ? 6 : new Date(date).getDay() - 1];
}
export default CheckDay;
